// Registers the service worker in production builds and cleans up any
// previously-installed SW in dev so stale caches don't haunt local work.
export function registerServiceWorker(): void {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Dev / preview without PROD flag: nuke any leftover SW + caches so a hot
  // reload never serves yesterday's bundle.
  if (!import.meta.env.PROD) {
    void navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => void r.unregister());
    });
    if ("caches" in window) {
      void caches.keys().then((keys) => keys.forEach((k) => void caches.delete(k)));
    }
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((registration) => {
        // Only reload on controllerchange if the page was ALREADY controlled
        // by a SW before this registration — that's the upgrade-takeover case.
        // On a first-ever install (no prior controller) the SW's clients.claim()
        // still fires controllerchange, but reloading then aborts any in-flight
        // requests (e.g. signInWithPassword on the login page) with ERR_ABORTED.
        if (navigator.serviceWorker.controller) {
          let reloaded = false;
          navigator.serviceWorker.addEventListener("controllerchange", () => {
            if (reloaded) return;
            reloaded = true;
            window.location.reload();
          });
        }

        // Force-activate any waiting worker found on initial load.
        if (registration.waiting) {
          registration.waiting.postMessage("SKIP_WAITING");
        }

        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // New version ready — tell it to take over.
              installing.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch((err) => {
        // Non-fatal: app works without SW.
        console.warn("[sw] registration failed:", err);
      });
  });
}
